import { useMemo, useState } from 'react'
import swal from 'sweetalert'
import { useNavigate } from 'react-router-dom'
import AuthService from 'Main/service/AuthService'

function Login () {
  const navigate = useNavigate()
  const authService = useMemo(() => new AuthService(), [])
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleLogin = async (event) => {
    event.preventDefault()
    setLoading(true)
    try {
      await authService.login(email.trim(), password)
      navigate('/dashboard', { replace: true })
    } catch (error) {
      const message = error?.response?.data?.message || 'Email or password is incorrect.'
      swal('Unable to sign in', message, 'error')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="artapay-login-card">
      <div className="artapay-login-heading">
        <span className="artapay-eyebrow">Welcome back</span>
        <h2>Sign in</h2>
      </div>

      <form onSubmit={handleLogin} className="artapay-login-form">
        <div className="artapay-field">
          <label htmlFor="login-email">Email address</label>
          <div className="artapay-input-wrap">
            <i className="fa-regular fa-envelope" />
            <input
              id="login-email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="name@company.com"
              required
              autoFocus
            />
          </div>
        </div>

        <div className="artapay-field">
          <label htmlFor="login-password">Password</label>
          <div className="artapay-input-wrap">
            <i className="fa-solid fa-lock" />
            <input
              id="login-password"
              type={showPassword ? 'text' : 'password'}
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Enter your password"
              required
            />
            <button
              type="button"
              className="artapay-password-toggle"
              onClick={() => setShowPassword((current) => !current)}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              <i className={`fa-regular ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} />
            </button>
          </div>
        </div>

        <button type="submit" className="artapay-primary-action" disabled={loading}>
          {loading
            ? <>
                <i className="fa-solid fa-circle-notch fa-spin" /> Signing in…
              </>
            : <>
                Sign in <i className="fa-solid fa-arrow-right" />
              </>
          }
        </button>
      </form>

      {/* <p className="artapay-login-note"><i className="fa-solid fa-lock" /> Your session is protected with a secure HTTP cookie.</p> */}
    </div>
  )
}

export default Login
